<template>
  <div class="idtr-account-wrap">
    <table class="idtr-table idtr-account">
      <colgroup>
        <col class="idtr-col--began" />
        <col class="idtr-col--discovered" />
        <col class="idtr-col--amount" />
      </colgroup>
      <tbody>
        <tr class="idtr-row--title">
          <td class="idtr-cell--head" colspan="3">
            {{ idtrTemplate.accountTitle }}
          </td>
        </tr>
        <tr class="idtr-row--company">
          <td class="idtr-cell--label" colspan="3">
            <field-label
              :target="fieldId('company')"
              class="idtr-account__label"
              >{{ text.company }}</field-label
            >
            <field-input
              :id="fieldId('company')"
              v-model="account.company"
              name="Company"
              rules="required"
              class="idtr-account__value"
            />
          </td>
        </tr>
        <tr class="idtr-row--number">
          <td class="idtr-cell--label" colspan="3">
            <field-label
              :target="fieldId('accountNumber')"
              class="idtr-account__label"
              >{{ text.accountNumber }}</field-label
            >
            <field-input
              :id="fieldId('accountNumber')"
              v-model="account.accountNumber"
              name="Account Number"
              rules="required"
              class="idtr-account__value"
            />
          </td>
        </tr>
        <tr class="idtr-row--head">
          <td class="idtr-cell--head">
            <field-label :target="fieldId('dateBegan')" class="idtr-cell-fill">{{
              text.dateBegan
            }}</field-label>
          </td>
          <td class="idtr-cell--head">
            <field-label :target="fieldId('dateDiscovered')" class="idtr-cell-fill">{{
              text.dateDiscovered
            }}</field-label>
          </td>
          <td class="idtr-cell--head">
            <field-label :target="fieldId('amount')" class="idtr-cell-fill">{{
              text.amount
            }}</field-label>
          </td>
        </tr>
        <tr class="idtr-row--value">
          <td>
            <field-input
              :id="fieldId('dateBegan')"
              v-model="account.dateBegan"
              name="Date fraud began"
              :rules="monthRules"
              date-format="M/YYYY"
            />
          </td>
          <td>
            <field-input
              :id="fieldId('dateDiscovered')"
              v-model="account.dateDiscovered"
              name="Date discovered"
              :rules="monthRules"
              date-format="M/YYYY"
            />
          </td>
          <td class="idtr-cell--amount">
            <field-label :target="fieldId('amount')" class="idtr-amount__prefix"
              >$ </field-label
            ><field-input
              :id="fieldId('amount')"
              v-model="account.amount"
              name="Amount"
              rules="required"
              digits
            />
          </td>
        </tr>
      </tbody>
    </table>
    <v-btn
      v-if="idtrForm.accounts.length > 1"
      class="idtr-account__remove"
      data-screen-only
      icon
      x-small
      color="red"
      title="Remove account"
      @click="$emit('remove', index)"
    >
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import FieldInput from "../FieldInput.vue";
import FieldLabel from "../FieldLabel.vue";
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {FieldInput, FieldLabel},
  inject: ["idtrForm", "idtrTemplate"],
  props: {index: {type: Number, required: true}},
  data: () => ({
    text: IDTR_TEXT,
    // M/YYYY or MM/YYYY, as printed in the original report (8/2026, 11/2019)
    monthRules: {
      required: true,
      regex: /^(0?[1-9]|1[0-2])\/\d{4}$/,
      notFutureMonth: true,
    },
  }),
  computed: {
    account() {
      return this.idtrForm.accounts[this.index];
    },
  },
  methods: {
    fieldId(field) {
      return `idtr-account-${this.index}-${field}`;
    },
  },
};
</script>
